import { render, staticRenderFns } from "./OptimizationGroupForm.vue?vue&type=template&id=03eb6508"
import script from "./OptimizationGroupForm.vue?vue&type=script&lang=js"
export * from "./OptimizationGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports